import { Component, inject } from '@angular/core';
import { AffordabilityService } from 'apps/lghf/src/app/services';

import { FieldBaseComponent } from '../base-component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaxLtvValidatorDirective } from '../../../forms/directives/max-ltv-validator.directive';
import { CurrencyMaskDirective } from '../../../forms/directives/currency-mask.directive';
import { FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-lib-ff-multi-question',
  styleUrls: ['./multi-question.component.scss'],
  templateUrl: './multi-question.component.html',
  imports: [FormsModule, MaxLtvValidatorDirective, CurrencyMaskDirective, ReactiveFormsModule, FormlyModule],
})
export class FormlyMultiFieldComponent extends FieldBaseComponent {
  private readonly affordabilityService = inject(AffordabilityService);

  public deleteField() {
    this.affordabilityService.deleteAdditionalBenefitField(this.applicantIndex, this.fieldName, this.fieldIndex);
  }

  public canDeleteField() {
    const fieldLength =
      this.affordabilityService.model.incomeAndExpenditure.applicants[this.applicantIndex][this.fieldName].length;
    return fieldLength > 1 && this.fieldIndex > 0;
  }

  public get applicantIndex() {
    return this.field.parent.parent.parent['index'];
  }

  public get fieldIndex() {
    return this.field.parent['index'];
  }

  public get fieldName() {
    return this.field['fieldName'];
  }
}
